export default "__VITE_ASSET__LOlXc_W___"